import type { ChangeEvent } from 'react';
import React, { memo, useCallback, useState } from 'react';

import type { KcContext } from 'keycloakify/login/KcContext';

import { Form } from 'src/shared/components/form/form.js';
import { Input } from 'src/shared/components/input/input.js';
import { useGetMsg } from 'src/shared/utils/kc-messages.js';

import { cnLoginOtp } from './login-otp.constants.js';

import './login-otp.css';

const otpRegex = /^\d{0,6}$/;

export interface LoginOtpProps {
    kcContext: KcContext.LoginOtp;
}

export const LoginOtp = memo<LoginOtpProps>(({ kcContext }) => {
    const { otpLogin, url } = kcContext;
    const { msgStr } = useGetMsg(kcContext);

    const [otp, setOtp] = useState('');
    const onChangeHandler = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        if (!e.target) {
            return;
        }
        const value = e.target.value;
        if (!otpRegex.test(value)) {
            return;
        }
        setOtp(value);
    }, []);
    return (
        <Form action={url.loginAction} kcContext={kcContext}>
            <div className={cnLoginOtp('text-block')}>
                <span className={cnLoginOtp('prompt')}>{msgStr('loginOtpOneTime')}</span>
            </div>

            <Input
                type="text"
                maxLength={6}
                id="otp"
                name="otp"
                label={msgStr('loginOtpCode')}
                autoComplete="off"
                autoFocus
                value={otp}
                onChange={onChangeHandler}
            />

            {otpLogin.userOtpCredentials.map((otpCredential) => (
                <div key={otpCredential.id}>
                    <Input hidden value={otpCredential.id} />
                </div>
            ))}

            <Input type="submit" value={msgStr('loginOtpSubmit')} disabled={otp.length < 6} />
        </Form>
    );
});
